import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlassWater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGlassWater"><Path d="M19.2539 3.75H4.75391L6.49562 17.6237C6.68401 19.1243 7.9599 20.25 9.47226 20.25H14.5356C16.0479 20.25 17.3238 19.1243 17.5122 17.6237L19.2539 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M5.5 9.49999C9.83333 7.76796 14.1667 11.2321 18.5 9.49999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconGlassWater;
